/*
 * Carrusel de portada: pasa solo de diapositiva, se puede deslizar, pausar y controlar con
 * flechas o puntos. Solo reproduce el vídeo de la diapositiva visible y, si la persona prefiere
 * menos movimiento, no avanza solo ni reproduce vídeos (se ve la primera imagen del vídeo).
 */
class MeluvaEscaparate extends HTMLElement {
  connectedCallback() {
    this.pista = this.querySelector('[data-pista]');
    this.diapositivas = [...this.querySelectorAll('[data-diapositiva]')];
    this.puntos = [...this.querySelectorAll('[data-punto]')];
    this.botonPausa = this.querySelector('[data-pausa]');
    this.intervalo = Number(this.dataset.intervalo) || 7000;
    this.menosMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.pausadoPorUsuario = this.menosMovimiento;
    this.actual = 0;
    if (this.diapositivas.length < 2) return;

    this.querySelector('[data-anterior]')?.addEventListener('click', () => this.ir(this.actual - 1, true));
    this.querySelector('[data-siguiente]')?.addEventListener('click', () => this.ir(this.actual + 1, true));
    this.puntos.forEach((punto) => punto.addEventListener('click', () => this.ir(Number(punto.dataset.punto), true)));
    this.botonPausa?.addEventListener('click', () => this.alternarPausa());
    this.actualizarBotonPausa();

    // La diapositiva visible manda: sirve igual para flechas, puntos o deslizar con el dedo
    this.observador = new IntersectionObserver(
      (entradas) => {
        entradas.forEach((entrada) => {
          if (entrada.isIntersecting && entrada.intersectionRatio >= 0.6) {
            this.marcar(this.diapositivas.indexOf(entrada.target));
          }
        });
      },
      { root: this.pista, threshold: [0.6] }
    );
    this.diapositivas.forEach((d) => this.observador.observe(d));

    // Pausa mientras se interactúa o la pestaña no está visible
    this.addEventListener('mouseenter', () => this.detener());
    this.addEventListener('mouseleave', () => this.programar());
    this.addEventListener('focusin', () => this.detener());
    this.addEventListener('focusout', (e) => {
      if (!this.contains(e.relatedTarget)) this.programar();
    });
    this.pista.addEventListener('touchstart', () => this.detener(), { passive: true });
    this.pista.addEventListener('touchend', () => this.programar(), { passive: true });
    document.addEventListener('visibilitychange', () => (document.hidden ? this.detener() : this.programar()));
    this.cambioFormato = window.matchMedia('(max-width: 989px)');
    this.cambioFormato.addEventListener('change', () => this.reproducirVisible());

    this.programar();
  }

  disconnectedCallback() {
    this.observador?.disconnect();
    this.detener();
  }

  ir(indice, porUsuario = false) {
    const total = this.diapositivas.length;
    const destino = (indice + total) % total;
    this.pista.scrollTo({ left: this.diapositivas[destino].offsetLeft, behavior: this.menosMovimiento ? 'auto' : 'smooth' });
    if (porUsuario) this.programar();
  }

  marcar(indice) {
    if (indice < 0) return;
    this.actual = indice;
    this.puntos.forEach((p, i) => p.setAttribute('aria-current', String(i === indice)));
    this.diapositivas.forEach((d, i) => d.toggleAttribute('inert', i !== indice));
    this.reproducirVisible();
  }

  reproducirVisible() {
    this.querySelectorAll('video').forEach((video) => {
      const enActual = this.diapositivas[this.actual]?.contains(video);
      const mostrado = video.offsetParent !== null;
      if (enActual && mostrado && !this.menosMovimiento) {
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    });
  }

  programar() {
    this.detener();
    if (this.pausadoPorUsuario || document.hidden) return;
    this.temporizador = window.setTimeout(() => this.ir(this.actual + 1), this.intervalo);
  }

  detener() {
    window.clearTimeout(this.temporizador);
  }

  alternarPausa() {
    this.pausadoPorUsuario = !this.pausadoPorUsuario;
    this.actualizarBotonPausa();
    this.pausadoPorUsuario ? this.detener() : this.programar();
  }

  actualizarBotonPausa() {
    if (!this.botonPausa) return;
    this.botonPausa.setAttribute('aria-pressed', String(this.pausadoPorUsuario));
    this.botonPausa.setAttribute('aria-label', this.pausadoPorUsuario ? 'Reanudar el carrusel' : 'Pausar el carrusel');
  }
}

if (!customElements.get('meluva-escaparate')) customElements.define('meluva-escaparate', MeluvaEscaparate);
